// Generated by ReScript, PLEASE EDIT WITH CARE


let setWindowProperty = (function(name, value) {
    window[name] = value;
  });

export {
  setWindowProperty,
}
/* No side effect */
